import { BetaDataTableCell as Cell, Tag, Text } from "@zapier/design-system";
import styles from "./ConnectionAppCell.module.css";
import Link from "next/link";
import { TooltipText } from "@zapier/shared";
import { ComponentProps } from "react";

interface ImplementationBadge {
  label?: string | null;
  color?: string | null;
  tooltip_markdown?: string | null;
}
interface Props {
  name: string;
  version: string | null | undefined;
  href?: string;
  badges?: ImplementationBadge[] | null;
}

type TagVariant = ComponentProps<typeof Tag>["variant"];

export function ConnectionAppCell({ name, version, href, badges }: Props) {
  return (
    <Cell>
      <span className={styles.root}>
        <TooltipText
          id={`connection-app-name-${name}`}
          label={version ? `${name} (${version})` : name}
          placement="bottom"
        >
          {href ? (
            <Link href={href}>
              <Text type="Body1">{name}</Text>
            </Link>
          ) : (
            <Text type="Body1">{name}</Text>
          )}
          {!!version && (
            <Text
              type="MinimalPrint1Multiline"
              color="TextWeaker"
              className={styles.version}
            >
              {version}
            </Text>
          )}
        </TooltipText>
        {badges && badges.length > 0 ? (
          <TooltipText
            id={`connection-app-badges-${name}`}
            label={badges.map((badge) => badge.label!).join(", ")}
            placement="bottom"
          >
            <span className={styles.badgesOverflow}>
              <span className={styles.badges}>
                {badges.map((badge) => (
                  <Tag
                    key={badge.label!}
                    variant={badge.color! as unknown as TagVariant}
                  >
                    {badge.label!}
                  </Tag>
                ))}
              </span>
            </span>
          </TooltipText>
        ) : undefined}
      </span>
    </Cell>
  );
}
